import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormField } from '../formDefinition';

@Component({
    selector: 'app-dynamic-view',
    templateUrl: './dynamic-view.component.html',
    styleUrls: ['./dynamic-view.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicViewComponent implements OnInit {

  _formFields: FormField[] = [];

  @Input() set formFields(value: FormField[]) {
    this._formFields = value;
  }

  get formFields() {
    return this._formFields;
  }

  @Input() formData: any;


  getOptionForField(field: FormField) {
    if (field.options) {
      return field.options.find(o => o.value === this.formData[field.group][field.name].toString())?.label;
    }
    else {
      return "";
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  visibleForParent(field: FormField) {
    if (field.parentControl) {

      const keySplit = field.parentControl.formKey.split(".");

      let visibleValue = field.parentControl.visibleValue;
      if (typeof visibleValue === 'string') {
        visibleValue = [visibleValue];
      }

      return visibleValue.includes(this.formData[keySplit[0]][keySplit[1]].toString())

    }

    return true
  }

}
